import CustomText from "../atomic/CustomText";
import DetailRenderer from "../global/forms/DetailRenderer";

const ClinicianInformation = ({ order }: any) => (
  <div>
    <CustomText
      text="CLINICIAN Information"
      fontWeight="font-medium"
      className="reviewCardHeading my-5"
    />
    <div className="reviewCard">
      <DetailRenderer
        data={order.clinicianInfoOrganization}
        groupFields={[
          "name",
          "address",
          "city",
          "state",
          "zipcode",
          "phone",
          "fax",
        ]}
        hiddenFields={[]}
        MainHeading="Organization"
      />
      <DetailRenderer
        data={order.clinicianInfoPhysician}
        groupFields={[
          "firstName",
          "lastName",
          "suffix",
          "npi",
          "specialty",
          "email",
        ]}
        hiddenFields={[]}
        MainHeading="Contact Info"
      />
    </div>
  </div>
);

export default ClinicianInformation;